import { Box, createMuiTheme, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import closeButton from 'src/images/settingclose.svg';
// import Information from './Information';
// import Subscription from './Subscription';
import CustomFont from './CustomFont';

interface SettingsModalProps {
  handleClose: React.MouseEventHandler<HTMLButtonElement>;
  currentTab: string | (() => string);
}

const customTheme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1300,
      xl: 1920
    }
  }
});

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'Archivo',
    fontWeight: 600,
    fontSize: 25,
    lineHeight: '27.2px',
    marginTop: '6vh'
  },
  contents: {
    padding: '0 5vw',
    [customTheme.breakpoints.down('md')]: {
      padding: 0,
      margin: '0 auto',
      width: 405
    }
  },
  tabs: {
    display: 'flex',
    listStyle: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '14.52px',
    marginTop: 20
  },
  tab: {
    marginRight: '2vw',
    paddingBottom: 5,
    cursor: 'pointer'
  }
}));

const SettingsModal: FC<SettingsModalProps> = props => {
  const classes = useStyles();

  return (
    <>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: '2vw'
        }}
      >
        <button
          onClick={props.handleClose}
          style={{ background: '#fff', border: 'none', cursor: 'pointer' }}
        >
          <img
            alt="close"
            src={closeButton}
            style={{ width: 26, height: 26 }}
          />
        </button>
      </Box>
      <Box className={classes.contents}>
        <Box>{props.currentTab === 'customfont' && <CustomFont />}</Box>
      </Box>
    </>
  );
};

export default SettingsModal;
